import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { OfflineSupplier } from 'src/types/catalog/Supplier';
import axiosInstance from 'src/utils/axios';

const useGetOfflineSuppliersApi = (
  catalogId: number | null,
  enabled = true
): UseQueryResult<OfflineSupplier[]> =>
  useQuery<OfflineSupplier[]>({
    queryKey: [...queryKeys.product.offlineSuppliers(catalogId)],
    queryFn: async (): Promise<OfflineSupplier[]> => {
      const res = await axiosInstance.get<OfflineSupplier[]>(
        api.getCatalogOfflineSuppliers(catalogId!)
      );
      return res.data;
    },
    enabled: enabled && catalogId !== null,
  });

export default useGetOfflineSuppliersApi;
